module.exports = __webpack_public_path__ + "img/img1.e07d9142.svg";